import React, { useEffect, useState } from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import ChangePriceModeScreen from "@scenes/more/ChangePriceModeScreen";
import { showToast, ToastTypes } from "../VDBToast/util";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTheme } from "styled-components/native";

const PriceModeModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const userInfo = useUserInfo();

  const [priceModeUpdate, setPriceModeUpdate] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const [enableToast, setEnableToast] = useState(false);

  useEffect(() => {
    if (userInfo.user?.price_mode === 2) {
      setEnableToast(true);
    } else {
      setEnableToast(false);
    }
  }, [userInfo.user?.price_mode]);

  useEffect(() => {
    if (theme.isLargeScreen && toastMessage) {
      showToast(
        t("priceMode.priceMarkup.toastMessageSuccess.title"),
        toastMessage,
        ToastTypes.SUCCESS,
        true,
        true
      );
      setToastMessage(null);
    }
  }, [toastMessage, theme.isLargeScreen, t]);

  useEffect(() => {
    if (priceModeUpdate) {
      showToast(
        t("priceMode.priceMode.toastMessageSuccess.title"),
        t("priceMode.priceMode.toastMessageSuccessDescription.title"),
        ToastTypes.SUCCESS,
        true,
        true
      );
      setPriceModeUpdate(false);
    }
  }, [priceModeUpdate]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      headerTitle={t("navigation.profile.general.label.priceMode")}
      enableToastMessage={enableToast ? true : false}
    >
      <ChangePriceModeScreen
        removeExtraSpacing
        closeModal={onClose}
        setPriceModeUpdate={setPriceModeUpdate}
        setToastMessage={theme.isLargeScreen ? setToastMessage : undefined}
      />
    </Modal>
  );
};

export default PriceModeModal;
